import { render } from "./MyTeam.vue?vue&type=template&id=7d22426e&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"

import "./MyTeam.vue?vue&type=style&index=0&id=7d22426e&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d22426e"]])

export default __exports__